<template>
  <hc-table :tableData="state.tableData" :column="state.column" :isHidePage="true" />
</template>

<script setup>
import hcTable from "@/components/hc-home/table.vue";
import { pageListApi } from "@/api/maintenance/maintenance.js";
import { reactive, onMounted } from "vue";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyMaintenanceTodoColumns } from "@/utils/homeDashboardI18n.js";

const state = reactive({
  tableData: [],
  column: [
    { type: "index", label: "序号", width: 60 },
    { prop: "title", label: "任务名称" },
    { prop: "real_name", label: "提交人" },
    { prop: "score", label: "分值", width: 70 },
    { prop: "created_at", label: "创建时间", width: 160 },
  ],
})

const applyLabels = () => {
  applyMaintenanceTodoColumns(state.column)
}
const { t } = usePageI18n(applyLabels)

const getTableData = () => {
  pageListApi(JSON.stringify({
    page: 1,
    limit: 8,
    status: 1,
    keywords: ""
  })).then(res => {
    state.tableData = res?.data ?? []
  })
}

onMounted(() => {
  applyLabels()
  getTableData()
})
</script>
